export default {
  acceptable: '#66a636',
  rudimentary: '#F6A526',
  inadequate: '#c50720'
};



// WEBPACK FOOTER //
// ./src/constants/securityDashboardColors.js